import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import { installKeyboardNav } from "./utils/keyboardNav";

// Tally-style keys (Enter / arrows to move between fields, Esc to close a popup) and no value changes on mouse-wheel scroll
installKeyboardNav();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
